import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Team from './components/Team';
import Features from './components/Features';
import Gallery from './components/Gallery';
import Hours from './components/Hours';
import Map from './components/Map';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <div className="container">
        <About />
        <Team />
        <Features />
        <Gallery />
        <Hours />
        <Map />
        <Contact />
      </div>
      <Footer />
    </div>
  );
}

export default App;